const authenticationSuccess = function() {
    console.log('Successful authentication');
  };

  const authenticationFailure = function() {
    console.log('Failed authentication');
  };

window.Trello.authorize({
  type: 'popup',
  name: 'Gyeon Brief App',
  scope: {
      read: 'false',
      write: 'true' },
  expiration: 'never',
  success: authenticationSuccess,
  error: authenticationFailure
});


/**
 * form submit data
 */
const submit = document.querySelector('#gyeonbrief');

const formSubmit = (e) => {
  e.preventDefault();
  // const myList = '58a2b08ff4bf14bb815ec3eb';
  const myList = '5eda1843604b6687658d2dcd'

  const frm = $("#gyeonbrief").serializeArray();
  const obj = {};
  for (let a = 0; a < frm.length; a++) {
    obj[frm[a].name] = frm[a].value;
  }

  const cleanData = {
    title: obj['title'] != '' ? obj['title'] : 'Not filled',
    description: obj['description'] != '' ? obj['description'] : 'Not filled',
    purpose: obj['purpose'] != '' ? obj['purpose'] : 'Not filled',
    guidelines: obj['guidelines'] != '' ? obj['guidelines'] : 'Not filled',
    benchmarks: obj['benchmarks'] != '' ? obj['benchmarks'] : 'Not filled',
    content: obj['content'] != '' ? obj['content'] : 'Not filled',
    files: obj['files'] != '' ? obj['files'] : 'Not filled',
    spec: obj['spec'] != '' ? obj['spec'] : 'Not filled',
    distribution: obj['distribution'] != '' ? obj['distribution'] : 'Not filled',
    deadlineideas: obj['deadlineideas'] != '' ? obj['deadlineideas'] : 'Not filled',
    deadlinecreation: obj['deadlinecreation'] != '' ? obj['deadlinecreation'] : 'Not filled',
    deadlineproduction: obj['deadlineproduction'] != '' ? obj['deadlineproduction'] : 'Not filled',
    budget: obj['budget'] != '' ? obj['budget'] : 'Not filled',
  }

  const briefContent = `
Task description
----------------
${cleanData['description']}.

---
Purpose & target group
----------------
${cleanData['purpose']}

---
Guidelines and mandatory elements of creation
----------------
${cleanData['guidelines']}

---
Mood & benchmarks
----------------
${cleanData['benchmarks']}

---
Merits / texts / dropbox links
----------------
${cleanData['content']}

---
Files & formats requested
----------------
${cleanData['files']}

---
Production spec- locistics
----------------
${cleanData['spec']}

---
Shipping / distibution
----------------
${cleanData['distribution']}

---
TIMING
----------------
Dates:

- Deadline for ideas: **${cleanData['deadlineideas']}**
- Deadline for final creation: **${cleanData['deadlinecreation']}**
- Deadline for production/final files: **${cleanData['deadlineproduction']}**

---
Budget
----------------
${cleanData['budget']}`

  $('#gyeonbrief').validate({
    debug: true,
    // success: "valid",
    rules: {
      title: "required",
      description: "required",
      purpose: "required",
      guidelines: "required",
      files: "required",
      deadlineproduction: "required"
    },
    messages: {
      title: "Please specify title",
      description: "Please write short but in detail description",
      purpose:"Please write purpose and target group",
      guidelines: "Please guidelines and mandatory elements of creation",
      files: "Please insert link for the files & formats requested",
      deadlineproduction: "Please write final deadline"
    },
    invalidHandler: function(event, validator) {
      const errors = validator.numberOfInvalids();
      $('html, body').animate({
        scrollTop: $(validator.errorList[0].element).offset().top - 100
      }, 1000);
      if (errors) {
        $("div.error").show();
      } else {
        $("div.error").hide();
      }
    },
  });

  const newCard = {
    name: cleanData['title'],
    desc: briefContent,
    idList: myList,
    pos: 'top'
  };

  const creationSuccess = function () {
    console.log('Card created successfully.');
    successMessage();
    document.getElementById("gyeonbrief").reset();
  };

  const successMessage = () =>{
    $('#messageSuccess').fadeIn().delay(3000).fadeOut(0);
  }

  /**
   * submit brief if validation pass
   */
  if($('#gyeonbrief').valid() == true) {
    window.Trello.post('/cards/', newCard, creationSuccess);
  }
};

submit.addEventListener('submit', formSubmit);
